import React from 'react';

const WalletTxModal = ({ visible, tx, onConfirm, onCancel }) => {
  if (!visible) return null;
  const { method, from, to, fee, payload } = tx || {};

  return (
    <div className="wallet-modal-overlay" onClick={onCancel}>
      <div className="wallet-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="wallet-modal-header">
          <h2>Review Transaction</h2>
          <button className="wallet-modal-close" onClick={onCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>

        <p className="wallet-modal-subtitle">Always verify transaction details before signing.</p>

        <div className="wallet-options-grid">
          <div className="wallet-option">
            <div className="wallet-option-button" style={{cursor:'default'}}>
              <div style={{flex:1}}>
                <h3 style={{margin:0}}>Summary</h3>
                <p style={{margin:'6px 0 0 0'}}>Method: {method || 'N/A'}</p>
                <p style={{margin:'6px 0 0 0'}}>From: {from || 'N/A'}</p>
                <p style={{margin:'6px 0 0 0'}}>To: {to || 'N/A'}</p>
                <p style={{margin:'6px 0 0 0'}}>Fee: {fee != null ? fee : 'N/A'}</p>
              </div>
            </div>
          </div>
          {payload && (
            <div className="wallet-option">
              <div className="wallet-option-button" style={{cursor:'default'}}>
                <div style={{flex:1}}>
                  <h3 style={{margin:0}}>Payload</h3>
                  <pre style={{whiteSpace:'pre-wrap', margin:0}}>{typeof payload === 'string' ? payload : JSON.stringify(payload, null, 2)}</pre>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="wallet-modal-footer" style={{display:'flex', gap:12, justifyContent:'flex-end'}}>
          <button className="wallet-modal-close" onClick={onCancel}>Cancel</button>
          <button className="start-tutorial-button" onClick={onConfirm}>Sign Transaction</button>
        </div>
      </div>
    </div>
  );
};

export default WalletTxModal;


